import { getProductsList } from '@/services/productService'
import { generateValueLabelFormate } from '../../components/ui/select/selectStyle'
export interface OptionType {
  value: string
  label: string
}

export const productOptions = async (inputValue: string) => {
  const productList: OptionType[] = await getProductsList(inputValue)
  return generateValueLabelFormate(productList) ?? []
}

export const productNoOptionText = (
  productSearchText: string,
  isGettingData: boolean
) => {
  return productSearchText === ''
    ? 'Type to show Products'
    : isGettingData
      ? 'Loading...'
      : 'Product Not Available'
}
